module.exports = __webpack_public_path__ + "media/scholarship_winners/jason-sw-bb12c7c1.png";